var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFooterDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 33,
    viewBox: "0 0 84 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_33052_3189)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.0247 19.264H43.0437L41.9025 22.0248H38.8477L44.5886 9.14258H47.5321L53.2939 22.0248H50.1625L49.0247 19.264ZM48.087 17.0024L46.0447 12.0704L44.0006 17.0024H48.087Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.567 12.3444C59.2077 12.0878 59.8933 11.9624 60.5833 11.9755V14.6251C60.2632 14.6007 60.0492 14.5885 59.9379 14.5885C59.1168 14.5885 58.4731 14.8205 58.0068 15.2844C57.5406 15.7483 57.3087 16.4384 57.311 17.3546V22.0291H54.4353V12.1234H57.1788V13.4299C57.5301 12.9446 58.0113 12.5684 58.567 12.3444Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5452 18.1409L65.1656 19.503V22.0238H62.2952V8.36914H65.1656V16.0985L69.3617 12.1233H72.7853L68.6623 16.3246L73.1524 22.029H69.6731L66.5452 18.1409Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9586 21.5201C75.1462 21.111 74.4642 20.4832 73.9893 19.7074C73.5255 18.908 73.2812 18.0003 73.2812 17.0762C73.2812 16.152 73.5255 15.2443 73.9893 14.4449C74.4642 13.6692 75.1462 13.0414 75.9586 12.6322C76.841 12.1854 77.8192 11.9609 78.8081 11.9781C79.7604 11.9558 80.7022 12.1812 81.5412 12.6322C82.3013 13.0463 82.9004 13.7037 83.2425 14.4988L81.0158 15.6957C80.5008 14.7876 79.7586 14.3336 78.789 14.3336C78.4455 14.323 78.1035 14.3828 77.7839 14.5094C77.4644 14.6359 77.1742 14.8265 76.931 15.0695C76.4428 15.56 76.1986 16.2287 76.1986 17.0753C76.1986 17.9219 76.4439 18.5911 76.9345 19.0829C77.1776 19.3258 77.4679 19.5164 77.7874 19.6429C78.1069 19.7695 78.449 19.8293 78.7925 19.8188C79.7736 19.8188 80.5159 19.3647 81.0193 18.4566L83.246 19.6744C82.8938 20.4564 82.2966 21.1024 81.5446 21.5149C80.706 21.9706 79.7623 22.198 78.8081 22.1743C77.8192 22.1914 76.841 21.9669 75.9586 21.5201Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3608 0.679688H11.2026C8.44626 0.679688 5.80282 1.77464 3.85379 3.72366C1.90477 5.67269 0.809814 8.31613 0.809814 11.0725V22.2307C0.809814 24.987 1.90477 27.6305 3.85379 29.5795C5.80282 31.5285 8.44626 32.6235 11.2026 32.6235H22.3608C25.1172 32.6235 27.7606 31.5285 29.7096 29.5795C31.6587 27.6305 32.7536 24.987 32.7536 22.2307V11.0725C32.7536 8.31613 31.6587 5.67269 29.7096 3.72366C27.7606 1.77464 25.1172 0.679688 22.3608 0.679688ZM10.3571 23.0849L12.3995 18.1529L15.2891 21.0425L10.3571 23.0849ZM17.0096 22.215L18.1456 19.4577L13.9182 15.2355L11.1591 16.3802L9.00017 14.2195L22.1695 9.17449L24.2571 11.2621L19.2207 24.4453L17.0096 22.215Z",
    fill: "#8C52FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_33052_3189"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82.4272,
    height: 31.9438,
    fill: "white",
    transform: "translate(0.809814 0.679688)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterDark);
export default __webpack_public_path__ + "static/media/footer-dark.fee93dfa2c3faa22d0b5f3e89bcf3431.svg";
export { ForwardRef as ReactComponent };